import React from 'react';
import { HEADER_WIDE_BOX_HANDICAP_TYPES } from '../data/constants';
import { classIf, getBetDescription, getHandicapSelections, getTournamentUniqueId, showMatchDesc, getAggregationAndBetFromBetId, getGenericHandicapDescriptionPart } from '../data/utils';
import HeaderUOBox from './HeaderUOBox';

function BetsOddsHeader(props) {
    const bets = props.bets;
    const selectionsById = props.matches ? getHandicapSelections(props.matches) : null;

	function getMarketDescriptionParam(bet){
		const aggregateContainer = getAggregationAndBetFromBetId(bet.cs, 0);
		if(aggregateContainer.market){
			let desc = aggregateContainer.market.desc;
			desc = desc.replaceAll('@@H1@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 1))
                       .replaceAll('@@H2@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 2))
                       .replaceAll('@@H3@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 3))
                       .replaceAll('@@H4@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 4))
                       .replaceAll('@@H5@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 5))
                       .replaceAll('@@H6@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 6))
                       .replaceAll('@@H7@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 7))
                       .replaceAll('@@H8@@', getGenericHandicapDescriptionPart(bet.cs, bet.h, 8))
                       .replaceAll('{{H1}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 1))
                       .replaceAll('{{H2}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 2))
                       .replaceAll('{{H3}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 3))
                       .replaceAll('{{H4}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 4))
                       .replaceAll('{{H5}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 5))
                       .replaceAll('{{H6}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 6))
                       .replaceAll('{{H7}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 7))
                       .replaceAll('{{H8}}', getGenericHandicapDescriptionPart(bet.cs, bet.h, 8));
            return desc;
		}
		
		return getBetDescription(bet, true);
	}

    const sportRef = props.matches?.[0].sportRef ?? null;

    return (
        <>
            {bets.map((bet, betIndex) => {
                let descHeader = bet.parametrica? getMarketDescriptionParam(bet) : getBetDescription(bet, true, sportRef);
                return (
                    <div key={`${bet.uniqueId}_${betIndex}`} className="gridInterernaQuotazioni d-flex justify-content-center align-items-center">
                        <div className="tabellaQuoteIntestazione-GruppoQuote text-uppercase d-flex justify-content-center align-items-center">
                            <p>{descHeader}</p>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            {bet.odds.map(((odd, j) => {
                                const betData = odd.betData;
                                let oddDesc = odd.desc;
                                if (betData.hideHandicap) {
                                    oddDesc = `${odd.desc} ${getBetDescription(betData, true)}`;
                                }
                                if (HEADER_WIDE_BOX_HANDICAP_TYPES.includes(bet.tipoHandicap)) {
                                    oddDesc = bet.eqs.find(e => e.ce === odd.id).d;
                                }
                                let selections = null;
                                return (
                                    <React.Fragment key={`${odd.betId}_${odd.betData.handicap}_${odd.id}`}>
                                        {bet.parametrica && j === 0 &&
                                            (((selections = selectionsById?.get(bet.id)?.selections?.sort((a, b) => a.handicap - b.handicap)) && props.matches.length > 1) ?
                                                <HeaderUOBox default={bet.handicapTableDesc} selections={selections} baseId={getTournamentUniqueId(props.matches[0].uniqueId)} />
                                                :
                                                <div key={`hcp-${odd.id}`} className={"tabellaQuoteIntestazione-QuotaSingola text-uppercase d-flex justify-content-center align-items-center" + (HEADER_WIDE_BOX_HANDICAP_TYPES.includes(bet.tipoHandicap)? " bottone-quota-largo" : "")}>
                                                    <p>{bet.handicapTableDesc}</p>
                                                </div>
                                            )
                                        }
                                        <div className={"tabellaQuoteIntestazione-QuotaSingola text-uppercase d-flex justify-content-center align-items-center pointer" + classIf(showMatchDesc(odd), 'quotaSingolaConNomeSquadra')}>
                                            <p>{oddDesc}</p>
                                        </div>
                                    </React.Fragment>
                                );
                            }))}
                        </div>
                    </div>
                )
            })}
        </>
    );
}

export default BetsOddsHeader;